import { render, staticRenderFns } from "./SurveyQuestionModalHeader.vue?vue&type=template&id=b1da4360&"
import script from "./SurveyQuestionModalHeader.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestionModalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports